import * as PropTypes from "prop-types"
import { I18n } from "react-polyglot-hooks"
import RentingScene from "scenes/RentingScene"
import { useRouter } from "next/router"
import { getNewCarsData } from "services/webService"
import LoadingScene from "scenes/LoadingScene"
import RentingContextProvider from "scenes/RentingScene/RentingContext"
import common from "../../../i18n/es/common"
import car from "../../../i18n/es/car"
import renting from "../../../i18n/es/renting"
import NotFound from "../../404"
import { getFooterLinks, getLandingsList } from "../../../src/services/seoService"

export default function Renting({ cars, preOwnedCars, kilometers, durations, brands, footerLinks, landingsList, notFound, sellingStatus }) {
  const { isFallback } = useRouter()

  if (isFallback)
    return (
      <I18n locale="es" phrases={common}>
        <LoadingScene />
      </I18n>
    )

  if (notFound) return <NotFound />

  return (
    <I18n locale="es" phrases={{ ...common, ...car, ...renting }}>
      <RentingContextProvider
        cars={cars}
        preOwnedCars={preOwnedCars}
        kilometers={kilometers}
        durations={durations}
        brands={brands}
        footerLinks={footerLinks}
        landingsList={landingsList}
        sellingStatus={sellingStatus}
        page="stock">
        <RentingScene />
      </RentingContextProvider>
    </I18n>
  )
}

Renting.defaultProps = {
  cars: [],
  preOwnedCars: [],
  kilometers: [],
  durations: [],
  footerLinks: [],
  landingsList: [],
  brands: {},
  notFound: false,
  sellingStatus: 'new'
}

Renting.propTypes = {
  cars: PropTypes.array,
  preOwnedCars: PropTypes.array,
  kilometers: PropTypes.array,
  durations: PropTypes.array,
  footerLinks: PropTypes.array,
  landingsList: PropTypes.array,
  brands: PropTypes.object,
  notFound: PropTypes.bool,
  sellingStatus: PropTypes.string
}

export async function getStaticProps() {
  try {
    const res = await getNewCarsData("es")

    if (res.status === 404) return { props: { notFound: true }, revalidate: 300 }

    // Footer Links
    const footerLinksRes = await getFooterLinks()
    const footerLinks = await footerLinksRes.json()

    // Landing List
    const landingListRes = await getLandingsList();
    const landingListdata = await landingListRes.json();
    const landingsList = Object.keys(landingListdata).map((key) => ({
      key,
      value: landingListdata[key],
    }));

    const data = await res.json()
    const { cars, preOwnedCars, kms: kilometers, durations, brands } = data

    return { props: { cars, preOwnedCars, kilometers, durations, brands, footerLinks, landingsList, sellingStatus: "new" }, revalidate: 300 }
  } catch (error) {
    console.error('Error en getStaticProps de renting:', error);
    return { 
      props: { notFound: true }, 
      revalidate: 60 // Intentar de nuevo en 60 segundos
    };
  }
}
